const INVISIBLE_CATEGORIES = [
  "Quick Lessons ( <1 hour)",
  "Deep Dives (2hrs +)",
  "Win at Work",
];

enum CATEGORY_IDS {
  Short = "6",
  Deep = "7",
  Win = "8",
  Language = "1",
}

export { INVISIBLE_CATEGORIES, CATEGORY_IDS };
